import { useReducer } from "react";

import { PERIODS, PeriodsType } from "./types";

export const initial: State = {
	isError: false,
	isLoading: false,
	selectedPeriod: PERIODS[0]
};

export interface State {
	isError: boolean;
	isLoading: boolean;
	selectedPeriod: PeriodsType;
}

enum ActionType {
	onSetStatus = "onSetStatus",
	onSelectPeriod = "onSelectPeriod"
}

export enum StatusRequest {
	onFetch = "onFetch",
	onError = "onError",
	onSuccess = "onSuccess"
}

interface Action {
	type: string;
	val: string;
}

function reducer(state: State, action: Action): State {
	switch (action.type) {
		case ActionType.onSelectPeriod:
			return { ...state, selectedPeriod: action.val as PeriodsType };
		case ActionType.onSetStatus:
			switch (action.val) {
				case StatusRequest.onFetch:
					return {
						...state,
						isLoading: true
					};
				case StatusRequest.onError:
					return {
						...state,
						isLoading: false,
						isError: true
					};
				case StatusRequest.onSuccess:
					return {
						...state,
						isLoading: false,
						isError: false
					};
				default:
					throw new Error("status request not found");
			}
		default:
			throw new Error("action type not found");
	}
}

export default function useConnectionsPeriodsStore() {
	const [state, dispatch] = useReducer(reducer, initial);

	const actions = {
		onSelectPeriod: (val: PeriodsType) => {
			dispatch({ type: ActionType.onSelectPeriod, val });
		},
		onSetStatus: (val: StatusRequest) => {
			dispatch({ type: ActionType.onSetStatus, val });
		}
	};

	return [state, actions] as const;
}
